var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"white-box shadow-box p-12",staticStyle:{"height":"50vh"},attrs:{"title":"Pendiente de definir"}},[_vm._v(" TBD... ")])}
var staticRenderFns = []

export { render, staticRenderFns }